var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBibleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_18390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.62826 1.98889L4.21338 1.02777L14.0449 0.167623C14.2273 0.15167 14.3877 0.286294 14.4036 0.468635L15.7807 16.208C15.7933 16.3522 15.7407 16.4955 15.6377 16.598L14.5907 17.6317L13.2542 1.09536L1.62826 1.98889Z",
    fill: "#FBDDC8",
    stroke: "#F96B21",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M3.60239 1.37695L4.27913 1.15071L14.1107 0.290559C14.293 0.274606 14.4534 0.40923 14.4694 0.591571L15.8464 16.331C15.859 16.4752 15.6602 16.6847 15.5573 16.7872L14.1558 0.654082C14.1465 0.547992 14.0528 0.469336 13.9484 0.478472L3.60225 1.37529L3.60239 1.37695Z",
    fill: "#F96B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74457 1.97542L12.8823 1.00099C13.1956 0.973582 13.4732 1.20653 13.5006 1.51982L14.8621 17.0818C14.8906 17.4068 14.6502 17.695 14.3236 17.7236L3.20744 18.6961C2.88254 18.7246 2.59426 18.4842 2.56569 18.1577L1.20593 2.61551C1.1775 2.29061 1.41786 2.00233 1.74442 1.97376L1.74457 1.97542Z",
    fill: "#FFDFCA",
    stroke: "#F96B21",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M4.94768 14.8575C2.91131 12.2011 4.72277 8.64013 4.28906 5.30565C4.07087 3.63269 3.38984 2.54976 2.76388 1.88628L2.07264 1.94676C1.56539 1.99113 1.18316 2.35697 1.21869 2.7631L2.55292 18.0135C2.58846 18.4196 3.02841 18.7135 3.53565 18.6691L13.9656 17.7566C13.9656 17.7566 6.9842 17.5156 4.94617 14.8593L4.94768 14.8575Z",
    fill: "#F96B21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_257_18390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5596 23.0111L9.75612 22.0532L8.85302 22.8618L9.04297 20.6907L10.7496 20.84L10.5596 23.0111Z",
    fill: "#FDDFCA",
    stroke: "#FB6B21",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2894 3.11945L9.41686 2.08073C9.06906 2.0503 8.76156 2.31763 8.73005 2.67781L7.22628 19.866C7.19477 20.2262 7.45117 20.5428 7.79897 20.5733L19.6715 21.612C20.0193 21.6424 20.3268 21.3751 20.3583 21.0149L21.8621 3.82672C21.8936 3.46653 21.6372 3.14987 21.2894 3.11945Z",
    fill: "#FCA466",
    stroke: "#FB6B21",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M16.7477 9.6823L15.0957 9.53776L15.2334 7.96378C15.2443 7.83814 15.1551 7.72791 15.0338 7.7173L13.9992 7.62679C13.8779 7.61617 13.7708 7.70922 13.7599 7.83486L13.6221 9.40884L11.9701 9.26431C11.8488 9.25369 11.7417 9.34675 11.7307 9.47238L11.637 10.5438C11.626 10.6695 11.7152 10.7797 11.8366 10.7903L13.4886 10.9348L13.0879 15.5156C13.0769 15.6413 13.1661 15.7515 13.2874 15.7621L14.322 15.8526C14.4434 15.8632 14.5504 15.7702 14.5614 15.6445L14.9621 11.0637L16.6142 11.2083C16.7355 11.2189 16.8426 11.1258 16.8536 11.0002L16.9473 9.92877C16.9583 9.80314 16.869 9.69291 16.7477 9.6823Z",
    fill: "#FB6B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.458 9.2734L15.5865 9.10966L15.7441 7.3084L14.2719 7.17961L14.1143 8.98087L12.2428 8.81713L12.1093 10.3431L13.9808 10.5069L13.5602 15.3149L15.0323 15.4437L15.453 10.6356L17.3245 10.7994L17.458 9.2734Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M9.7019 16.6928C8.49998 13.4753 10.5569 9.91852 10.7627 6.23246C10.8653 4.38372 10.4958 3.09679 10.1009 2.27278L9.5325 2.22305C9.11551 2.18515 8.74573 2.51837 8.7067 2.96445L7.24158 19.7108C7.20256 20.1569 7.50899 20.5478 7.9261 20.5843L16.5027 21.3347C16.5027 21.3347 10.9038 19.9103 9.70066 16.6913L9.7019 16.6928Z",
    fill: "#F96B21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_18390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5914,
    height: 17.7697,
    fill: "white",
    transform: "translate(0.951172 1.18457) rotate(-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_257_18390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4559,
    height: 21.0345,
    fill: "white",
    transform: "translate(8.66406 1.87256) rotate(5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibleIcon);
export default __webpack_public_path__ + "static/media/bible_icon.99145fcc3002792efc0dddf882636ba3.svg";
export { ForwardRef as ReactComponent };